const user = {
  newUser: "Neuer Benutzer",
  firstName: "Vorname",
  lastName: "Nachname",
  email: "E-Mail-Addresse",
  company: "Unternehmen",
  userLevel: "Benutzerlevel",
  password: "Passwort",
  confirm: "bestätigen",
  btn: "Neuen Benutzer erstellen",
  save: "Änderungen speichern",
  metric: "Einheitensystem",
  imperial: "Kaiserliche",
  language: "Sprache",
  userProfile: "Benutzerprofil",
  userList: "Benutzerliste",
  search: "Suche",
  disable: "Deaktiviert",
  actions: "Aktionen",
  date: "Datum erstellt",
  reset: "Passwort zurücksetzen",
  submit: "Absenden",
  plant: "Zone"
};
export default user;
